import Enviroment from "./components/Enviroments";
import React, { useEffect } from 'react';
import Gmaps from "./components/Map";
import Footer from "./components/Footer";

function App() {

    useEffect(() => {
        if (!document.querySelector("#quick-launch-script")) {
          const script = document.createElement("script");
          script.src = "https://webservice.possumus.tech/quicklaunch/quicklaunch.js"; // Replace with actual URL
          script.async = true;
          script.id = "quick-launch-script";
          document.body.appendChild(script);
        }
    }, []);

    return (
        <>
            <Enviroment />
            <Gmaps />
            <quick-launch></quick-launch>
            <Footer />
        </>
    );
}

export default App;
